import Votacao from "../Votacao";

export default function Arabes() {
  return <Votacao colecao="arabes" titulo="Perfumes Árabes" />;
}
